module.exports = "<img class=\"{{classes}}\" *ngIf=\"fileUrl\" [src]=\"fileUrl\" (click)=\"onClick()\">"